import { Text } from '@wework/dieter-ui'
import * as _ from 'lodash'
import Row from '../../Common/Row'
import React from 'react'

export default function LinkPreview({
  containerStyle = {},
  img = false,
  space,
}) {
  if (!space) {
    return null
  }

  return (
    <div style={styles.container}>
      <Row>
        <div>
          <Text size="tiny" style={{ fontWeight: '900' }}>
            {space.officeNumber}
          </Text>
          <Text size="tiny">
            {space.floor} floor • {space.type}
          </Text>
          <Text size="tiny" color="grey">
            {space.capacity} seats
          </Text>
          <Text size="tiny" color="grey">
            {space.displayPrice}
          </Text>
          {/* <Text size="tiny" color="grey">
              Whiteboard • Phone • TV
            </Text> */}
        </div>
      </Row>
    </div>
  )
}

const styles = {
  container: {
    border: '1px solid #E6E6E6',
    borderRadius: 8,
    padding: 16,
    marginLeft: 12,
  },
}
